// FCM Helper - Utility functions for Firebase Cloud Messaging
import { getFCMToken } from '../config/firebase';

/**
 * Get FCM token with error handling
 * This function will request permission and return the token
 * @returns {Promise<string|null>} FCM token or null
 */
export const requestFCMToken = async () => {
  try {
    const token = await getFCMToken();
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

/**
 * Check if browser supports notifications
 * @returns {boolean}
 */
export const isNotificationSupported = () => {
  if (typeof window === 'undefined') return false;
  return 'Notification' in window && 'serviceWorker' in navigator;
};

/**
 * Check current notification permission status
 * @returns {string} 'default', 'granted', or 'denied'
 */
export const getNotificationPermission = () => {
  if (!isNotificationSupported()) {
    return 'unsupported';
  }
  return Notification.permission;
};

